/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateFireExtinguisherCommandControllerCreate201,
  CreateFireExtinguisherDto,
  FireExtinguisherResponseDto,
  ListFireExtinguishersQueryControllerListParams,
  UpdateFireExtinguisherCommandControllerUpdate200,
  UpdateFireExtinguisherDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Register a fire extinguisher for a nursery
 */
export const createFireExtinguisherCommandControllerCreate = (
  nurseryId: string,
  createFireExtinguisherDto: CreateFireExtinguisherDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateFireExtinguisherCommandControllerCreate201>({
    url: `/v1/nurseries/${nurseryId}/fire-extinguishers`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createFireExtinguisherDto,
    signal,
  });
};

export const getCreateFireExtinguisherCommandControllerCreateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>,
    TError,
    { nurseryId: string; data: CreateFireExtinguisherDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateFireExtinguisherDto },
  TContext
> => {
  const mutationKey = ["createFireExtinguisherCommandControllerCreate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>,
    { nurseryId: string; data: CreateFireExtinguisherDto }
  > = (props) => {
    const { nurseryId, data } = props ?? {};

    return createFireExtinguisherCommandControllerCreate(nurseryId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFireExtinguisherCommandControllerCreateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>
  >;
export type CreateFireExtinguisherCommandControllerCreateMutationBody =
  CreateFireExtinguisherDto;
export type CreateFireExtinguisherCommandControllerCreateMutationError = void;

/**
 * @summary Register a fire extinguisher for a nursery
 */
export const useCreateFireExtinguisherCommandControllerCreate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>,
      TError,
      { nurseryId: string; data: CreateFireExtinguisherDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFireExtinguisherCommandControllerCreate>>,
  TError,
  { nurseryId: string; data: CreateFireExtinguisherDto },
  TContext
> => {
  return useMutation(
    getCreateFireExtinguisherCommandControllerCreateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary List all fire extinguishers for a nursery
 */
export const listFireExtinguishersQueryControllerList = (
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
  signal?: AbortSignal,
) => {
  return axiosClient<FireExtinguisherResponseDto[]>({
    url: `/v1/nurseries/${nurseryId}/fire-extinguishers`,
    method: "GET",
    params,
    signal,
  });
};

export const getListFireExtinguishersQueryControllerListQueryKey = (
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
) => {
  return [
    `/v1/nurseries/${nurseryId}/fire-extinguishers`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFireExtinguishersQueryControllerListQueryOptions = <
  TData = Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListFireExtinguishersQueryControllerListQueryKey(nurseryId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>
  > = ({ signal }) =>
    listFireExtinguishersQueryControllerList(nurseryId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: nurseryId !== null && nurseryId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFireExtinguishersQueryControllerListQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>
>;
export type ListFireExtinguishersQueryControllerListQueryError = void;

export function useListFireExtinguishersQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params: undefined | ListFireExtinguishersQueryControllerListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireExtinguishersQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
          TError,
          Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFireExtinguishersQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List all fire extinguishers for a nursery
 */

export function useListFireExtinguishersQueryControllerList<
  TData = Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
  TError = void,
>(
  nurseryId: string,
  params?: ListFireExtinguishersQueryControllerListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFireExtinguishersQueryControllerList>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFireExtinguishersQueryControllerListQueryOptions(
    nurseryId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a fire extinguisher
 */
export const updateFireExtinguisherCommandControllerUpdate = (
  nurseryId: string,
  fireExtinguisherId: string,
  updateFireExtinguisherDto: UpdateFireExtinguisherDto,
  signal?: AbortSignal,
) => {
  return axiosClient<UpdateFireExtinguisherCommandControllerUpdate200>({
    url: `/v1/nurseries/${nurseryId}/fire-extinguishers/${fireExtinguisherId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateFireExtinguisherDto,
    signal,
  });
};

export const getUpdateFireExtinguisherCommandControllerUpdateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>,
    TError,
    {
      nurseryId: string;
      fireExtinguisherId: string;
      data: UpdateFireExtinguisherDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>,
  TError,
  {
    nurseryId: string;
    fireExtinguisherId: string;
    data: UpdateFireExtinguisherDto;
  },
  TContext
> => {
  const mutationKey = ["updateFireExtinguisherCommandControllerUpdate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>,
    {
      nurseryId: string;
      fireExtinguisherId: string;
      data: UpdateFireExtinguisherDto;
    }
  > = (props) => {
    const { nurseryId, fireExtinguisherId, data } = props ?? {};

    return updateFireExtinguisherCommandControllerUpdate(
      nurseryId,
      fireExtinguisherId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFireExtinguisherCommandControllerUpdateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>
  >;
export type UpdateFireExtinguisherCommandControllerUpdateMutationBody =
  UpdateFireExtinguisherDto;
export type UpdateFireExtinguisherCommandControllerUpdateMutationError = void;

/**
 * @summary Update a fire extinguisher
 */
export const useUpdateFireExtinguisherCommandControllerUpdate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>,
      TError,
      {
        nurseryId: string;
        fireExtinguisherId: string;
        data: UpdateFireExtinguisherDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateFireExtinguisherCommandControllerUpdate>>,
  TError,
  {
    nurseryId: string;
    fireExtinguisherId: string;
    data: UpdateFireExtinguisherDto;
  },
  TContext
> => {
  return useMutation(
    getUpdateFireExtinguisherCommandControllerUpdateMutationOptions(options),
    queryClient,
  );
};
